import { Flag } from "@/services/generatedApi";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export type FeatureFlagLookup = { [key: string]: boolean };

export interface FeatureFlagError {
  message: string;
  failureCount: number;
}

export interface FeatureFlagState {
  status: "idle" | "loading" | "error" | "success";
  error: FeatureFlagError | undefined;
  data: FeatureFlagLookup;
}

const initialState: FeatureFlagState = {
  status: "idle",
  error: undefined,
  data: {},
};

export const featureFlagsSlice = createSlice({
  name: "featureFlags",
  initialState,
  reducers: {
    error(state, action: PayloadAction<FeatureFlagError>) {
      state.status = "error";
      state.error = action.payload;
    },
    loading(state) {
      state.status = "loading";
    },
    success(state, action: PayloadAction<Flag[]>) {
      state.status = "success";
      state.data = action.payload.reduce((acc, flag) => ({ ...acc, [flag.flag_name]: flag.enabled }), {});
    },
  },
});
